import {TRY_SEND_LOGS} from "../constants/client-log.constants";

export const trySendLogs = () => {
	return {
		type: TRY_SEND_LOGS
	}
}
